import React from 'react';
import RentennialsNextImage from '@components/images/RentennialsNextImage';
import { useLocale } from 'next-intl';

interface SocialNetworksProps {}

const SocialNetworks = ({}: SocialNetworksProps) => {
  const locale = useLocale();
  //flex w-full justify-center gap-x-3 pt-2 tablet:w-auto tablet:justify-between
  return (
    <div className="flex w-full items-center justify-center gap-x-3 tablet:w-fit tablet:justify-end">
      <a
        href={
          locale === 'en' ? 'https://www.instagram.com/rentennials_eeuu/' : 'https://www.instagram.com/rentennials.app/'
        }
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-gray-100 text-rentennials-text hover:bg-rentennials-primary hover:text-white"
      >
        <RentennialsNextImage
          priority
          alt="instagram-logo"
          src="/images/landing/Instagram_Icon.svg"
          className="h-8 w-8 tablet:h-10 tablet:w-10 "
        />
      </a>
      <a
        href={
          locale === 'en'
            ? 'https://www.facebook.com/profile.php?id=61563935204865'
            : 'https://www.facebook.com/Rentennials'
        }
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-gray-100 text-rentennials-text hover:bg-rentennials-primary hover:text-white"
      >
        <RentennialsNextImage
          priority
          alt="facebook-logo"
          src="/images/landing/Facebook_Icon.svg"
          className="h-8 w-8 tablet:h-10 tablet:w-10 "
        />
      </a>
      <a
        href="https://ar.pinterest.com/rentennials/"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-gray-100 text-rentennials-text hover:bg-rentennials-primary hover:text-white"
      >
        <RentennialsNextImage
          priority
          alt="pinterest-logo"
          src="/images/landing/Pinterest_Icon.svg"
          className="h-8 w-8 tablet:h-10 tablet:w-10 "
        />
      </a>
      <a
        href="https://x.com/rentennials"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-gray-100 text-rentennials-text hover:bg-rentennials-primary hover:text-white"
      >
        <RentennialsNextImage
          priority
          alt="x-logo"
          src="/images/landing/X_Icon.svg"
          className="h-8 w-8 tablet:h-10 tablet:w-10 "
        />
      </a>
      <a
        href="https://www.youtube.com/@rentennialsapp/videos"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-gray-100 text-rentennials-text hover:bg-rentennials-primary hover:text-white"
      >
        <RentennialsNextImage
          priority
          alt="youtube-logo"
          src="/images/landing/Youtube_Icon.svg"
          className="h-8 w-8 tablet:h-10 tablet:w-10 "
        />
      </a>
      <a
        href="https://www.linkedin.com/company/rentennials/"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-gray-100 text-rentennials-text hover:bg-rentennials-primary hover:text-white"
      >
        <RentennialsNextImage
          priority
          alt="linkedin-logo"
          src="/images/landing/LinkedIn_Icon.svg"
          className="h-8 w-8 tablet:h-10 tablet:w-10 "
        />
      </a>
      <a
        href="https://open.spotify.com/user/314dt5dx4tobcyokobz2njyjm2zq?si=4844eb8305764111"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-gray-100 text-rentennials-text hover:bg-rentennials-primary hover:text-white"
      >
        <RentennialsNextImage
          priority
          alt="spotify-logo"
          src="/images/landing/Spotify_Icon.svg"
          className="h-8 w-8 tablet:h-10 tablet:w-10 "
        />
      </a>
    </div>
  );
};

export default SocialNetworks;
